import { userProfile, UserProfileProps } from "@/services/user-profile";
import { useToast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";

export const useAPIUserProfile = () => {
  const { toast, showToastByCode } = useToast();
  const { t } = useTranslation();
  
  const handleAPIUserProfile = async (params: UserProfileProps) => {
    try {
      const res = await userProfile(params);
      toast({
        title: t("use_api_user_profile.modification_successful_title"),
        description: t("use_api_user_profile.modification_successful_description"),
      });
      return res;
    } catch (error) {
      showToastByCode(error);
      throw error;
    }
  };

  return {
    handleAPIUserProfile,
  };
};
